import EntityForm from "@/mixins/EntityForm";
import Component, {
  mixins
} from "vue-class-component";

@Component({
  inject: {
    languageService: "languageService",
    privacyService: "privacyService",
    eventService: "eventService",
    userService: "userService",
  },
})
export default class PrivacyForm extends mixins(EntityForm) {
  model = {};
  platformLanguages = [];

  get elements() {
    return [{
        id: "code",
        label: this.translations.labels.privacy_form_code,
        type: "text",
        required: true,
        rules: "min:4",
        onAction: this.noSpaces,
      },
      {
        id: "type",
        label: this.translations.labels.privacy_form_type,
        type: "select",
        items: this.types,
        required: true
      },
      {
        id: "required",
        label: this.translations.labels.privacy_form_required,
        type: "switch"
      },
      {
        id: "localizations",
        type: "localizations",
        header: this.translations.labels.form_localizations,
        languages: this.languages,
        resetColumns: true,
        elements: [{
            id: "title",
            label: this.translations.labels.privacy_form_title,
            type: "text",
            rules: "max:200",
            required: this.isText(),
            hide: () => {
              return !this.isText();
            },
          },
          {
            id: "label",
            label: this.translations.labels.privacy_form_wording,
            type: "text",
            rules: "max:200",
            required: true
          },
          {
            id: "description",
            label: this.translations.labels.privacy_form_description,
            type: "wysiwyg",
            required: this.isText(),
            resetColumns: 1,
            hide: () => {
              return !this.isText();
            },
          }
        ],
      },
    ];
  }

  get types() {
    return this.privacyService.getPrivacyTypes();
  }

  get languages() {
    return this.platformLanguages;
  }

  get helpLink() {
    return this.translations.pageHelp.privacy;
  }

  isText() {
    return this.model.type == "Text";
  }

  noSpaces(evt) {
    let charCode = evt.charCode;
    if (charCode === 32) evt.preventDefault();
    return true;
  }

  // eslint-disable-next-line no-empty-function
  afterCreate() {}

  async created() {
    this.platformLanguages = await this.languageService.list();
    this.afterCreate();
  }
}